import hsts from "refractor/hsts";
export default hsts;